import api from './api';

const gurukulService = {
  // Public - Get All Gurukuls
  getAllGurukuls: async (params) => {
    const response = await api.get('/gurukul', { params });
    return response.data;
  },

  // Public - Get Gurukul Profile
  getGurukulProfile: async (id) => {
    const response = await api.get(`/gurukul/${id}`);
    return response.data;
  },

  // Admin - Create Gurukul
  createGurukul: async (data) => {
    const response = await api.post('/admin/gurukul', data);
    return response.data;
  },

  /** Public self-registration: same payload shape as admin create; backend creates pending Gurukul + CANDIDATE user until approved */
  registerGurukulApplication: async (data) => {
    const response = await api.post('/gurukul/register', data);
    return response.data;
  },

  /** Admin: approve a self-registered Gurukul account (activates login + public listing per backend rules) */
  approveGurukulRegistration: async (id) => {
    const response = await api.post(`/admin/gurukul/${id}/approve`);
    return response.data;
  },

  // Admin - Get All Gurukuls (Admin View)
  getAdminGurukuls: async (params) => {
    const response = await api.get('/admin/gurukul', { params });
    return response.data;
  },

  // Admin - Get Gurukul Details
  getGurukul: async (id) => {
    const response = await api.get(`/admin/gurukul/${id}`);
    return response.data;
  },

  // Admin - Update Gurukul
  updateGurukul: async (id, data) => {
    const response = await api.put(`/admin/gurukul/${id}`, data);
    return response.data;
  },

  // Admin - Delete Gurukul
  deleteGurukul: async (id) => {
    const response = await api.delete(`/admin/gurukul/${id}`);
    return response.data;
  },

  // Admin - Download Sample CSV
  downloadSample: async () => {
    const response = await api.get('/admin/gurukul/export/sample', {
      responseType: 'blob',
    });
    return response.data;
  },

  // Admin - Import Gurukuls
  importGurukuls: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/admin/gurukul/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Admin - Create Expenditure
  createExpenditure: async (id, data) => {
    const response = await api.post(`/admin/gurukul/${id}/expenditure`, data);
    return response.data;
  },

  // Public/Admin - Get Expenditures
  getExpenditures: async (id) => {
    const response = await api.get(`/gurukul/${id}/expenditure`);
    return response.data;
  },
};

export default gurukulService;
